module.exports = __webpack_public_path__ + "static/img/HW_app_moni.75c048d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/HW_app_moni.jpg
// module id = 50
// module chunks = 1 2